//variablen muessen pro instanz angepasst werden
module.exports = {
    mantelUrl : 'https://mantel-api.mobile.documedias.systems/v2/conferences/',
    baseUrl: 'https://mantel-api.mobile.documedias.systems/v2/checkall/',
    baseUrlDownload: 'https://mantel-api.mobile.documedias.systems/v2/downloadall/',
    baseUrlCDN: "https://documedias-188ab.kxcdn.com/",
    cdnInitStamp: "2022-04-13T14:12:33.808Z",
    conference: '1411',
    short_name: 'ispad2023',
    full_name: 'ISPAD 2023',
    api_version: 2, //change this to api version 2 for new conferences!!!
    conf_date : '27 – 29 October',
    api_url : 'https://coredev.api.documedias.systems/api/',
    appointment_api_url : 'https://dev.appointment.documedias.systems/api/',
    auth_url : 'https://auth.documedias.com/',
    auth_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoyMDE2LCJjb25ncmVzc0lkIjoxNDExLCJkYXRlIjoiMjAyMy0wOS0xM1QwNzoxNDowOS43OTdaIiwiaWF0IjoxNjk0NTg5MjQ5fQ.A6lzHBwgRggL3h7wq31_0tkwDQ1x_0M9fO8qmP_H2TE',
    auth_dev_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoyMDE1LCJjb25ncmVzc0lkIjoxNDExLCJkYXRlIjoiMjAyMy0wOS0xM1QwNzoxMzo0OS4yNjhaIiwiaWF0IjoxNjk0NTg5MjI5fQ.wnTEDmbUsemG1tNDCuyRzxG8bDnhHiI1BozA31CWXGI',
    vue_app_access_key : 'eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo5LCJjb25ncmVzc0lkIjoxLCJkYXRlIjoiMjAxOC0xMC0wMVQwOTo0Njo0MC42MDlaIiwiaWF0IjoxNTM4Mzg3MjAwfQ.1Z8vRJF2gZtCuLDEWxQhNyvlYHS6YZsdJxvoYGfyo112afY8CofuEBP4_jvIPXhc',
    chat_url: 'https://ispad2023.chat.documedias.systems/api/',
    is_app: false, //unbedingt anpassen bevor App deploy
    favorite_api_url: 'https://ispad2023.planner.documedias.systems/api/program/favorites',
    is_multi_conf_app: false //set true for society or Conf2Go

}
